import React from 'react';

export default function OffDutyChip() {
  return (
    <span className="px-2 py-1 text-xs text-gray-100 rounded bg-salmon-600">
      OFF DUTY
    </span>
  );
};
